import { useMemo } from 'react';
import { ReactFlow, Background, BackgroundVariant } from '@xyflow/react';
import { useWorkflows } from '@/store/workflows';
import { buildGraph } from '@/lib/layout';
import { SourceNode } from './nodes/SourceNode';
import { SpikeNode } from './nodes/SpikeNode';
import { FinalizedNode } from './nodes/FinalizedNode';
import { EditNode } from './nodes/EditNode';
import { GateNode } from './nodes/GateNode';
import { OutputNode } from './nodes/OutputNode';

const nodeTypes = {
  source: SourceNode,
  spike: SpikeNode,
  finalized: FinalizedNode,
  edit: EditNode,
  gate: GateNode,
  output: OutputNode
};

export function WorkflowChain() {
  const workflows = useWorkflows((s) => s.workflows);
  const { nodes, edges } = useMemo(() => buildGraph(workflows), [workflows]);
  return (
    <ReactFlow
      nodes={nodes}
      edges={edges}
      nodeTypes={nodeTypes}
      fitView
      fitViewOptions={{ padding: 0.2, maxZoom: 1, minZoom: 0.5 }}
      panOnDrag
      zoomOnScroll={false}
      zoomOnPinch
      panOnScroll
      proOptions={{ hideAttribution: true }}
      nodesConnectable={false}
      nodesDraggable={false}
      elementsSelectable={false}
      defaultEdgeOptions={{ deletable: false }}
    >
      <Background variant={BackgroundVariant.Dots} gap={28} size={1} color="var(--color-ink-800)" />
    </ReactFlow>
  );
}
